import { useMatch } from 'react-router';

// determines if the current route contains the (report-level) comments subroute
// example 1 (no commentId): /view/51/comments
// example 2 (with commentId): /view/51/comments/d158053e-72b9-4c3a-bb3e-dad621e65daf
// example 3 (opened from a form): /view/51/forms/some-toc-item-id/comments
export const useIsCommentsSubroute = () => {
    const bareMatch = useMatch('/view/:id/:subroute?/:commentId?');
    // Comments opened from a form keep the /forms/:tocItemId prefix in the URL so the form stays
    // displayed underneath the panel (formViewContext's showForm is regex-derived from the pathname
    // starting with /forms) — the bare pattern above alone won't match it.
    const formsMatch = useMatch('/view/:id/forms/:tocItemId/:subroute?/:commentId?');
    const match = bareMatch ?? formsMatch;
    const subroute = match?.params?.subroute;
    return !!(subroute && subroute.toLocaleLowerCase() === 'comments');
};
